@if (!!drugMatchOptions?.length) {
  <form>
    <div class="text-end mb-1">
      <button class="btn" [ngClass]="drugOcrButtonClass" (click)="onFindDrugsClick()">Find Drugs</button>
    </div>
    @for (drugMatchOption of drugMatchOptions; track drugMatchOption.key; let i = $index) {
      <div
        [id]="'drugMatch' + i"
        class="border rounded mb-1 p-1"
        >
        @if (!drugMatchOption.collapsed) {
          <div>
            <app-validate-drug-match-heading
              [key]="drugMatchOption.key"
              [name]="drugMatchOption.matchingPrescriberDrug.name"
              [position]="i"
              [showWarningIndicator]="drugMatchOption.checkedWrittenDatesHaveWarnings"
              [collapsed]="drugMatchOption.collapsed"
              (collapseChange)="onCollapseChange($event)"
              />
            <app-validate-drug-match-details
              [matchingPrescriberDrug]="drugMatchOption.matchingPrescriberDrug"
              [checkedWrittenDates]="drugMatchOption.checkedWrittenDates"
              />
            <div class="mt-3">Does the consult note reference the claim RX or class of RX?</div>
            <app-validate-drug-match-verification
              [drugMatchOption]="drugMatchOption"
              [position]="i"
              (verificationChange)="onDrugMatchesChange($event)"
              />
            @if (patientAttachment.drugMatchNotRequired) {
              <div class="alert alert-warning mt-1">
                This client does not require that the drug be referenced on the consult note. If the drug is not referenced you may select <em>No</em> and verify the capture.
              </div>
            }
          </div>
        } @else {
          <app-validate-drug-match-heading
            [key]="drugMatchOption.key"
            [name]="drugMatchOption.matchingPrescriberDrug.name"
            [position]="i"
            [showWarningIndicator]="drugMatchOption.checkedWrittenDatesHaveWarnings"
            [collapsed]="drugMatchOption.collapsed"
            (collapseChange)="onCollapseChange($event)"
            >
            <app-validate-drug-match-verification
              [drugMatchOption]="drugMatchOption"
              [position]="i"
              (verificationChange)="onDrugMatchesChange($event)"
              />
          </app-validate-drug-match-heading>
          <app-drug-akas [matchingPrescriberDrug]="drugMatchOption.matchingPrescriberDrug" />
          <div class="row g-0 mt-3">
            <div class="col">
              <div><strong>RX-DRUG(S)</strong></div>
              <div>{{ drugMatchOption.matchingPrescriberDrug.relatedDrugNames | joinList }}</div>
            </div>
          </div>
        }
        @if (!drugMatchOption.hideAdditionalDetails) {
          <app-additional-details-input
            [id]="drugMatchOption.key + 'Notes'"
            [frozen]="drugMatchOption.verification.frozen"
            [value]="drugMatchOption.verification.notes"
            [required]="!drugMatchOption.verification.frozen && drugMatchOption.verification.matches"
            (valueChange)="onAdditionalTextChange(drugMatchOption, $event)"
            />
        }
        @if (drugMatchOptions.length > 1 && i < drugMatchOptions.length - 1) {
          <div class="mt-1 text-end">
            <button class="btn btn-sm btn-secondary py-1" (click)="onNextClick($event, i, drugMatchOptions.length)">
              NEXT
            </button>
          </div>
        }
      </div>
    }
  </form>
} @else {
  <p>Please select a prescriber with scripts for this patient.</p>
}
